import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Layout from "components/layout/Layout";
import { Helmet } from "react-helmet";
import Salaries from "./Salaries";
import { PayoutHistory } from "../payout-history/PayoutHistory";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LOCALES } from "common/constants";

export const SalaryTabs = () => {
  const language = localStorage.getItem("i18nextLng");
  const [tabValue, settabValue] = useState("salaries");
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <Layout
      className="p-4 mt-5 create_invoices margin-top-98 invoice-space2 salary-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/salaries"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/loner"
          />
        )}
      </Helmet>

      <div className="pay-checks">
        <Tabs
          defaultActiveKey={location?.state ? "history" : "salaries"}
          id="uncontrolled-tab-example"
          className="mb-3"
          onSelect={(k) => settabValue(k)}
        >
          <Tab eventKey="salaries" title={t("Salaries")}>
            <Salaries tabValue={tabValue} />
          </Tab>
          <Tab eventKey="history" title={t("Holiday Payout History")}>
            <PayoutHistory tabValue={tabValue} />
          </Tab>
        </Tabs>
      </div>
    </Layout>
  );
};
